import cn from 'classnames/bind';
import React from 'react';
import { Text } from '@consta/uikit/Text';
import { Select } from '@consta/uikit/Select';
import styles from './styles.styl';
import { NumberLinesItems } from '../../utils/config';
import { Pagination } from '@consta/uikit/Pagination';
import { useMediaQuery } from 'react-responsive';

const cx = cn.bind(styles);

export interface ItemType {
  label: number;
  id: number;
}

export interface INumberLinesProps {
  handleChange?: ({ label, id }: ItemType) => void;
  valuePage?: ItemType;
  currentPage: number;
  onChangePagination?: (value: number) => void;
  totalPages: number;
  className?: string;
}

const NumberLines: React.FC<INumberLinesProps> = ({
  handleChange = () => {},
  valuePage,
  currentPage,
  onChangePagination = () => {},
  totalPages,
  className,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });
  return (
    <div className={cx('NumberLines', className)}>
      {valuePage && (
        <div className={cx('NumberLines__container')}>
          {!isMobile && (
            <Text size="xs" className={cx('NumberLines__title')}>
              Показывать на странице
            </Text>
          )}
          <Select
            className={cx('NumberLines__textField')}
            size="s"
            items={NumberLinesItems}
            value={valuePage}
            getItemLabel={(value) => String(value.label)}
            dropdownClassName={cx('NumberLines__dropTextField')}
            onChange={({ value }) => {
              handleChange(value);
            }}
          />
        </div>
      )}
      <Pagination
        position="right"
        currentPage={currentPage}
        onChange={(value) => onChangePagination(value)}
        totalPages={totalPages}
        className={cx('NumberLines__pagination')}
      />
    </div>
  );
};

export default NumberLines;
